import { dateFromLocal } from '@/lib/hours';

export function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

export function ymd(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function utcOffsetForTz(date: Date, tz: string): string {
  // longOffset returns 'GMT+02:00' / 'GMT-05:00' / 'GMT' (UTC).
  // shortOffset returns 'GMT+2' which DRF rejects (`+2` is not `+HH:MM`).
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: tz,
    timeZoneName: 'longOffset',
  }).formatToParts(date);
  const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value ?? 'GMT';
  const stripped = tzPart.replace(/^GMT/, '').replace(/^UTC/, '');
  return stripped === '' ? '+00:00' : stripped;
}

/** SC-1081 — `date`/`time` sont l'heure murale du restaurant ; le decalage est
 *  celui de CET instant-la (pas celui de la meme heure lue en UTC, qui se
 *  trompe d'une heure autour d'un changement d'heure). */
export function buildReservedFor(date: string, time: string, ianaTimezone: string): string {
  const [y, mo, d] = date.split('-').map(Number);
  const [hh, mm] = time.split(':').map(Number);
  const instant = dateFromLocal(y, mo, d, hh, mm, ianaTimezone);
  return `${date}T${time}:00${utcOffsetForTz(instant, ianaTimezone)}`;
}
